import React, { useEffect, useState } from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Grid from "@material-ui/core/Grid";
import Box from '@material-ui/core/Box';
import CoacheeDetail from './CoacheeDetail';
import ProgramDetails from './ProgramDetails';
import ProgramDimensions from './ProgramDimensions';
import CommercialsNBilling from './CommercialsNBilling';
import Sla from './SLA';
import ActivityLog from './ActivityLog';
import { Button, Dialog, DialogContent, DialogTitle, Link, Typography, Divider, FormControl, AppBar, Toolbar,FormControlLabel,Checkbox } from '@material-ui/core';
import DataClient from '../../../../../../Service/general_data_service';
import { useHistory, useLocation } from 'react-router-dom';
import { showSnackbar } from '../../../../../../Components/Snackbar/SnackbarActions';
import { useDispatch, useSelector } from 'react-redux';
import CustomInput from '../../../../../../Components/CustomInput';
import CustomSelect from '../../../../../../Components/CustomSelect';
import { CancellationReasons } from '../../../../../../Common/constant';
import moment from "moment";


const useStyles = makeStyles((theme) => ({
    tabRoot: {
        '& .MuiTabs-flexContainer': {
            justifyContent: "flex-start"
        },
        '& .MuiTabs-indicator': {
            backgroundColor: "transparent"
        }
    },
    tabs: {
        borderWidth: 1,
        borderStyle: "solid",
        borderColor: "#ddd",
        backgroundColor: "rgba(7,127,131,.75)",
        borderTopLeftRadius: 5,
        borderTopRightRadius: 5,
        marginRight: 10,
        // fontSize: "18px",
        // fontFamily: "Open Sans",
        minWidth: 130,
        textTransform: "none",
        "&:hover,&.Mui-selected": {

            color: "#fff",
            backgroundColor: "rgba(7,127,131,1)",
            opacity: 1
        }
    },
    title: {
        textTransform: "capitalize",
    },
    formWrapper: {
        background: "#fff",
        width: "500px",
        padding: theme.spacing(3),
    },
    dialog_title: {
        marginLeft: '1.5rem',
    },
    overviewContainer: {
        position: 'sticky', top: 64, paddingTop: 40, background: '#fff', zIndex: 1
    },
    linkTextColor: {
        color: theme.palette.secondary.main,
        textDecoration: "underline",
        textAlign: "left"
    }

}));

function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <Box role="tabpanel" hidden={value !== index} id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`} {...other}>
            {value === index && children}
        </Box>
    );
}

export default function AssignmentOverview(props) {

    const { start_date, expected_end_date } = props?.assignmentDetails
    const classes = useStyles();
    const dispatch = useDispatch();

    const history = useHistory();
    const location = useLocation();
    const [value, setValue] = React.useState(0);
    const [cancelFlag, setCancelFlag] = React.useState(false);
    const [userData, setUserData] = useState({
        reason: "",
        notes: ""
    })
    const [open, setOpen] = React.useState(false);
    const [displayContent, setDisplayContent] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };
    const [checked, setChecked] = useState(props?.assignmentDetails.statement_of_work);

    const [clientInvoicingSelectedId, setClientInvoicingSelectedId] =
    useState(undefined);
    const [clientInvoicingCheck, setClientInvoicingCheck] = useState(null);

    const handleClose = () => {
        setUserData({ ...userData, reason: "", notes: "" })
        setOpen(false);
    };

    const clientInvoicingHandle = (id, event) => {
        const { name } = event?.target;
        setClientInvoicingSelectedId(id);
        setClientInvoicingCheck(name === clientInvoicingCheck ? undefined : name);
      };
      const handleChange1 = (e) => {
        setChecked({
          ...checked,
          [e.target.name]: e.target.checked,
        });
      };
        const globaluserData = useSelector((state) => state.commonReducer);
        const userRole = globaluserData.role;
//   const userRole=sessionStorage.getItem("role");
    const tabArr = ["Coachee details", "Program details", "Program dimensions", "Commercials & Billing", "SLA", "Activity log"].map((el)=>{
        if(userRole!=="admin" && el==="SLA"){
        return ; 
    } 
        return el;    
    }).filter(el=>el!==undefined)
    const tabPanelArr = [
        <CoacheeDetail {...props} />,
        <ProgramDetails {...props} />,
        <ProgramDimensions {...props} />,
        // role !== "partner" &&
          <CommercialsNBilling {...props} />,
        // role !== "partner" && 
          <Sla {...props} />,
        // role !== "partner" &&
         <ActivityLog {...props} />
    ].map((el,ind)=>{
        if(userRole!=="admin" && ind===4){
        return ; 
    } 
        return el;    
    }).filter(el=>el!==undefined)

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    useEffect(() => {
        getData();
       
        (props.location?.state?.currentAssignment?.status == "Cancelled" || props?.assignmentDetails?.status == "Cancelled") && setCancelFlag(true);
        getCheckedData()
    }, [checked])

    const getData = (params) => {
        DataClient.getData('assignment_details/fetch_coachee_details?assignment_id=' + props.location?.state?.currentAssignment?.id)
            .then((res) => {
                // console.log(`res`, res)
            })
            .catch((res) => {

            })
    }
    const getCheckedData = (params) => {
        DataClient.getData(`assignment_details/statement_of_work?statement_of_work=${checked}&assignment_id=${props.location?.state?.currentAssignment?.id}`)
            .then((res) => {
                console.log(`res`, res)
                setDisplayContent(res.data)
            })
            .catch((res) => {

            })
    }
    const cancelAssignment = (params) => {
        DataClient.update({
            assignment_id: props.location.state.currentAssignment.id,
            cancellation_reason: userData?.cancellation_reason,
            other_cancellation_reason: userData?.other_cancellation_reason,
            additional_notes: userData.notes
        }, 'assignments/cancel_assignment')
            .then((res) => {
                dispatch(showSnackbar("success", ["Assignment cancelled successfully"]));
                setCancelFlag(true);
                props.getAssignmnetData();
                handleClose()

            })
            .catch((res) => {
            })
    }

    const setInputState = (inputStateValue, inputId) => {
        setUserData({ ...userData, [inputId]: inputStateValue })
    }

    const onChangeItem = (selectedItemValue) => {
        setUserData({ ...userData, [selectedItemValue.id]: selectedItemValue.value });
    };

    return <>
        <Grid container direction="row" justify="center" alignItems="center">
            <Grid item xs={11} style={{ textAlign: "center" }} direction="row" justify="center" alignItems="center" className={classes.overviewContainer}>
                <AppBar position="static" className={classes.appBar} elevation={0}>
                    <Toolbar>
                        <Grid container direction="row" justify="left" alignItems="left" xs={12}>
                            <Grid item xs={4}>
                                <Typography variant="h1" style={{ color: "#4A4A4A" }}>
                                    <Box textAlign="left" fontWeight="fontWeightBold">Assignment overview</Box>
                                    <Box textAlign="left" style={{ lineHeight: "20px" }} >
                                        <Link href="javascript:void(0)" className={classes.linkTextColor} onClick={() => {
                                            history.push({
                                                pathname: 'assignmentsummary', state: { currentAssignment: location?.state?.currentAssignment }
                                            })
                                        }} >
                                            <Typography variant="h2">
                                                View summary
                                            </Typography>
                                        </Link>
                                    </Box>
                                </Typography>

                            </Grid>
                            <Grid item xs={4} style={{ alignSelf: "center" }}>
                                <Box textAlign="right" >
                                  { userRole === "partner" &&
                                 
                                            // <Typography variant="h2">
                                            // Statement of work
                                            // </Typography>
                                                //   <FormControlLabel
                                                //   control={
                                                //     <Checkbox
                                                //       id="statement"
                                                //       name="statement"
                                                //     //   value={data.value}
                                                //       color="primary"
                                                //     //   checked={data.name === clientInvoicingCheck}
                                                //     />
                                                //   }
                                                //   style={{color:"#077F83", textDecoration:"underline"}}
                                                //   onChange={(e) => clientInvoicingHandle(data?.id, e)}
                                                //   label="Statement of work"
                                                //   className={classes.paper}
                                                // />
                                            //     <Checkbox
                                            //     onChange={checkHandler}
                                            //     value="checkedAll"
                                            //     checked={checkedAllState}
                                            // />
                                            <Typography  style={{ color: "#4A4A4A" }}>
                                    <Box textAlign="left" fontWeight="fontWeightBold">

                                            <FormControlLabel
                                            control={
                                              <Checkbox
                                                onChange={(e) => setChecked(e.target.checked)}
                                                value={checked}
                                                checked={checked}
                                                label="Statement of work"
                                                color="primary"
                                                name="statement_of_work"
                                                id="statement_of_work"
                                              />
                                            }
                                            label="Statement of work"
                                          />
                                          </Box>
                                          <Box textAlign="left" style={{ lineHeight: "20px", fontSize:"15px" }} >
                                          {(displayContent === "Acknowledged by Coachee on" || checked !== false || props?.assignmentDetails.statement_of_work !== false ) ? displayContent : ""}

                                            </Box>
                                          </Typography>
                                        }
                                </Box>
                            </Grid>
                            <Grid item xs={4} style={{ alignSelf: "center" }}>
                                <Box textAlign="right" >
                                  {/* { role !== "partner" && */}
                                    <Button disableElevation variant="contained" color="secondary"
                                        disabled={cancelFlag}
                                        onClick={handleClickOpen}
                                        style={{ backgroundColor: cancelFlag ? "#ddd" : "#C71C1C", color: "#fff", textTransform: "none" }}>{cancelFlag ? "Cancelled" : "Cancel"} assignment</Button>
                                        {/* } */}
                                </Box>
                            </Grid>
                        </Grid>
                      
                    </Toolbar>
                </AppBar>
            </Grid>
            <Grid item xs={11}>
                <Grid container direction="row" justify="flex-end" alignItems="center" style={{ marginTop: "10px" }}>
                    <Grid item xl={8} lg={6} md={4}></Grid>
                    <Grid item xl={2} lg={3} md={4}>
                        <Typography variant="h2" style={{ color: "#232323", textAlign: "end" }}>
                            <Box textAlign="right" fontWeight="fontWeightBold" component="span">Coaching start
                                date:&nbsp;</Box>
                            <Box textAlign="right" component="span">{start_date ? moment(start_date).format("DD/MM/YYYY") : 'TBD'}</Box>
                        </Typography>
                    </Grid>
                    <Grid item xl={2} lg={3} md={4}>
                        <Typography variant="h2" style={{ color: "#232323", textAlign: "end" }}>
                            <Box textAlign="right" fontWeight="fontWeightBold" component="span">Expected end
                                date:&nbsp;</Box>
                            <Box textAlign="right" component="span">{expected_end_date ? moment(expected_end_date).format("DD/MM/YYYY") : 'TBD'}</Box>
                        </Typography>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={11}>
                <Box my={5}>
                    <Tabs value={value} onChange={handleChange} classes={{ root: classes.tabRoot }}>
                        {
                            tabArr.map((option) => <Tab classes={{ root: classes.tabs }} label={option} />)
                        }
                    </Tabs>
                    {
                        tabPanelArr.map((option, index) => <TabPanel value={value}
                            index={index}>{option}</TabPanel>)
                    }
                </Box>
            </Grid>
        </Grid>
        <Dialog maxWidth={"sm"} fullWidth={true} open={open} onClose={handleClose}
            aria-labelledby="base-station-manage">
            <DialogTitle id="customized-dialog-title" className={classes.dialog_title}>
                <Typography variant="subtitle1" fontWeight="bold">Fill the information before cancelling the assignment</Typography>
            </DialogTitle>
            <Divider />
            <DialogContent style={{ margin: '0px auto' }}>
                <div className={classes.formWrapper}>
                    <form>
                        <div>
                            <Grid style={{ marginBottom: '2rem' }} container alignItems={"center"}>
                                <Grid item xs={3}>
                                    <Typography variant="h2" className={classes.title}>Cancellation reasons</Typography>
                                </Grid>
                                <Grid item xs={9}>
                                    <FormControl style={{ width: '100%' }} variant="outlined">
                                        <CustomSelect
                                            id="cancellation_reason"
                                            labelText="Cancellation reasons"
                                            displayEmpty
                                            variant="outlined"
                                            itemArr={CancellationReasons}
                                            parentcall={onChangeItem}
                                        />
                                    </FormControl>
                                </Grid>
                            </Grid>

                            {['Cancelled by client/individual before completion', 'Cancelled by Partner before completion', 'Other'].includes(userData?.cancellation_reason) ? <Grid style={{ marginBottom: '2rem' }} container alignItems={"center"}>
                                <Grid item xs={3}>
                                </Grid>
                                <Grid item xs={9}>
                                    <FormControl style={{ width: '100%' }} variant="outlined">
                                        <CustomInput id="other_cancellation_reason" variant="outlined" placeholder="Cancellation reason" multiline={true} rows={4} parentcall={setInputState} />
                                    </FormControl>
                                </Grid>
                            </Grid> : null}

                            <Grid style={{ marginBottom: '2rem' }} container >
                                <Grid item xs={3}>
                                    <Typography variant="h2" className={classes.title}>Additional notes</Typography>
                                </Grid>
                                <Grid item xs={9}>
                                    <FormControl style={{ width: '100%' }} variant="outlined">
                                        <CustomInput id="notes" variant="outlined" placeholder="Additional notes" multiline={true} rows={4} parentcall={setInputState} defaultValue={userData.notes} />
                                    </FormControl>
                                </Grid>
                            </Grid>
                            <Grid container spacing={1} alignItems={"center"} justify={"flex-end"}
                                style={{ marginTop: 20 }}>
                                <Grid item xs={2} style={{ marginRight: '1rem' }}>
                                    <Button disableElevation type="button" style={{ textTransform: 'capitalize' }}
                                        onClick={handleClose}
                                        variant={"contained"}>Cancel</Button>
                                </Grid>
                                <Grid item xs={2}>
                                    <Button disableElevation type="button" style={{ textTransform: 'capitalize' }}
                                        onClick={cancelAssignment}
                                        variant={"contained"}
                                        color="secondary">
                                        Save
                                    </Button>
                                </Grid>
                            </Grid>
                        </div>
                    </form>
                </div>
            </DialogContent>

        </Dialog>
    </>
}



